export const numericalErr = "At least one numerical digits (0-9)";
export const upperCaseReg = new RegExp(/^(?=.*\p{Lu})(?=.*\p{Ll})/u);
// Matches the server's RequireNonAlphanumeric: any character that is not an ASCII letter or digit.
export const specialCharsReg = new RegExp(/[^A-Za-z0-9]/);
export const numberReg = new RegExp(/\d/);
export const formatCamelCaseReg = (text: string) => {
  const result = text.replace(/([a-z](?=[A-Z]))/g, "$1 ");
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
};

// Placeholder value for missing or empty data
export const PLACEHOLDER_VALUE = "-";

export const PERMISSION_LIST = {
  ADD_USER: "addUser",
  REASSIGNMENT_OF_ENTRIES: "reassignmentOfEntries",
  DEACTIVATE_USER: "deactivateUser",
  ASSIGN_PERMISSIONS: "assignPermissions",
  UPDATE_USER_DETAILS_SETTINGS: "updateUserDetailsSettings",
  UPDATE_USER_DETAILS_FOR_OTHER_USERS: "updateUserDetailsForOtherUsers",
  RESEND_EMAIL_VERIFICATION: "resendEmailVerification",
  SEND_PASSWORD_RESET_LINK: "sendPasswordResetLink",
  REQUEST_PASSWORD_RESET: "requestPasswordReset",
  LOG_IN: "logIn",
  LOG_OUT: "logOut",
  RESET_PASSWORD: "resetPassword",
  VALIDATE_EMAIL: "validateEmail",
  INCIDENT_DETAILS: "incidentDetails",
  INCIDENT_FILTERS: "incidentFilters",
  INCIDENT_LIST: "incidentList",
  INCIDENT_SEARCH: "incidentSearch",
  CREATE_INCIDENT: "createIncident",
  SUBSCRIBE_TO_INCIDENT: "subscribeToIncident",
  UNSUBSCRIBE_FROM_INCIDENT: "unsubscribeFromIncident",
  EDIT_ALL_INCIDENTS_POST_SUBMISSION: "editAllIncidentsPostSubmission",
  EDIT_NOTES_ON_ALL_INCIDENTS: "editNotesOnAllIncidents",
  EDIT_NOTES_ON_OWN_INCIDENT: "editNotesOnOwnIncident",
  EDIT_OWN_INCIDENT_POST_SUBMISSION: "editOwnIncidentPostSubmission",
  EDIT_OWN_INCIDENT_PRE_SUBMISSION: "editOwnIncidentPreSubmission",
  DELETE_ATTACHMENT: "deleteAttachment",
  DELETE_INCIDENT: "deleteIncident",
  DELETE_NOTES_POST_SUBMISSION: "deleteNotesPostSubmission",
  DELETE_NOTES_PRE_SUBMISSION: "deleteNotesPreSubmission",
  ADD_ATTACHMENT_ON_ALL_INCIDENTS: "addAttachmentOnAllIncidents",
  ADD_ATTACHMENT_ON_OWN_INCIDENT: "addAttachmentOnOwnIncident",
  ADD_NOTE_ON_ALL_INCIDENTS: "addNoteOnAllIncidents",
  ADD_NOTE_ON_OWN_INCIDENT: "addNoteOnOwnIncident",
  ABILITY_TO_ADD_SIGNATURE_TO_INCIDENT: "abilityToAddSignatureToIncident",
  VIEW_NOTES_RECOMMENDATIONS_FROM_MR: "viewNotesRecommendationsFromMR",
  VIEW_REPORT: "viewReport",
  VIEW_REPORT_LIST: "viewReportList",
  SUBSCRIBE_TO_REPORT: "subscribeToReport",
  EXPORT_REPORT_AS_CSV: "exportReportAsCSV",
  EXPORT_REPORT_AS_EXCEL: "exportReportAsExcel",
  EXPORT_REPORT_AS_PDF: "exportReportAsPDF",
  EXPORT_REPORT_AS_WORD: "exportReportAsWord",
  HIGI_SEVERITY_INCIDENT: "highSeverityIncident",
  LOW_SEVERITY_INCIDENT: "lowSeverityIncident",
  CRITICAL_SEVERITY_INCIDENT: "criticalSeverityIncident",
  INCIDENT_SIGN_OFF_BEGIN: "incidentSignOffBegin",
  INCIDENT_SIGN_OFF_COMPLETE: "incidentSignOffComplete",
  INCIDENT_SUBMITTED_REOPENED: "incidentSubmittedReopened",
  INCIDENT_SIGNED_REOPENED: "incidentSignedReopened",
  INCIDENT_REOPENED_ALERT: "incidentReopenedAlert",
  SIGN_OFF_BEGUN_ALERT: "signOffBegunAlert",
  SIGNED_INCIDENT_REOPENED_ALERT: "signedIncidentReOpenedAlert",
  ALERT_SIGN_OFF_COMPLETED_ALERT: "alertSignOffCompletedAlert",
  CRITICAL_INCIDENT_ALERT: "criticalIncidentAlert",
  HIGH_SEVERITY_INCIDENT_ALERT: "highSeverityincidentAlert",
  LOW_SEVERITY_INCIDENT_ALERT: "lowSeverityIncidentAlert",
};

// Evaluates to TRUE if the user has the permission in the list
// @ts-ignore
export const PERMISSION_EVERY = (arr, cb): any => arr.every(cb);

// Evaluates to TRUE if the user has at least one permission in the list
// @ts-ignore
export const PERMISSION_SOME = (arr, cb): any => arr.some(cb);

export const MITIGATE_COLORS = {
  BLUE: ["#2c76a3", "#4c91ce", "#7db7e4"],
  GREEN: ["#23aba4", "#5db9b5", "#8cedc3"],
  RED: ["#ee3350", "#f0546d", "#f597a7"],
  ORANGE: ["#f7922d", "#f9b573", "#facb9b"],
  PURPLE: ["#462158", "#814197", "#a56dad", "#bf91c0", "#e1b8d5"],
};
